import React, { useState, useEffect } from "react";
import {
  SafeAreaView,
  ScrollView,
  View,
  Image,
  TextInput,
  Platform,
  TouchableOpacity,
  Alert,
} from "react-native";
import CustomizeText from "../components/CustomizeText";
import * as ImagePicker from "expo-image-picker";
import Ionicons from "react-native-vector-icons/Ionicons";
import { firebase } from "../../../firebase";
import "firebase/storage";
import styles from "../styles/Styles";
import { emojis } from "../utils/Constants";
import {withUserContext} from "../contexts/UserContext";

const CheckIn = ({global}) => {
  const [message, setMessage] = useState("");
  const [image, setImage] = useState(null);
  const [emoji, setEmoji] = useState(0);

  useEffect(() => {
    (async () => {
      if (Platform.OS !== "web") {
        const {
          status,
        } = await ImagePicker.requestMediaLibraryPermissionsAsync();
        if (status !== "granted") {
          alert("Sorry, we need camera roll permissions to make this work!");
        }
      }
    })();
  }, []);

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.All,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
    });

    if (!result.cancelled) {
      setImage(result.uri);
    }
  };

  const getEmojiStyle = (currId) => {
    if (currId === emoji) {
      return [styles.emojiImage, styles.selectedEmoji];
    } else {
      return styles.emojiImage;
    }
  };

  const uploadImage = async (currDate) => {
    if (image) {
      const response = await fetch(image);
      const blob = await response.blob();
      let ref = firebase
        .storage()
        .ref("images/" + global.name + "_" + currDate.getTime());
      return ref.put(blob).then((snap) => {
        return snap.ref.getDownloadURL();
      });
    } else {
      return null;
    }
  };

  const handleSubmit = () => {
    let currDate = new Date();
    // upload image
    uploadImage(currDate)
      .then((imageUrl) => {
        // then push checkin data to database
        let checkin = {
          message: message,
          emoji: emoji,
          date: currDate,
        };
        if (imageUrl) {
          checkin["image"] = imageUrl;
        }
        let update = {};
        const checkinRef = firebase
          .database()
          .ref("family/fid1/member/kids/uid1/message");
        const cid = checkinRef.push().getKey();
        update["family/fid1/member/kids/" + global.uid + "/message/" + cid] = checkin;
        console.log("family/fid1/member/kids/" + global.uid + "/message/" + cid)

        firebase
          .database()
          .ref()
          .update(update)
          .then(() => {
            alert("Your Quick Check-in has been sent to your families!");
            Alert.alert(
              "Submit Success!",
              "Your Quick Check-in has been sent to your families!",
              [{ text: "OK", onPress: () => console.log("OK Pressed") }],
              { cancelable: false }
            );
            setEmoji(0);
            setMessage("");
            setImage(null);
          })
          .catch((err) => {
            alert("Some error occurs!");
            Alert.alert(
              "Some Error Occurs",
              err,
              [{ text: "OK", onPress: () => console.log("OK Pressed") }],
              { cancelable: false }
            );
          });
      })
      .catch((err) => {
        alert("Some error occurs!");
        Alert.alert(
          "Some Error Occurs",
          err,
          [{ text: "OK", onPress: () => console.log("OK Pressed") }],
          { cancelable: false }
        );
      });
  };

  return (
    <View style={{ flex: 1 }}>
      <SafeAreaView style={styles.safeAreaContainer}>
        <ScrollView contentContainerStyle={styles.scrollViewContainer}>
          <CustomizeText style={styles.title}>How was your day?</CustomizeText>
          <View style={styles.emojiList}>
            {emojis.map((emoji) => (
              <TouchableOpacity
                key={emoji.id}
                style={styles.emojiImageContainer}
                onPress={() => {
                  setEmoji(emoji.id)
                  setMessage(emoji.defaultMessage)
                }}
              >
                <Image style={getEmojiStyle(emoji.id)} source={emoji.img} />
              </TouchableOpacity>
            ))}
          </View>
          <CustomizeText style={styles.subtitle}>
            Anything else to share?
          </CustomizeText>
          <TextInput
            style={styles.messageInput}
            onChangeText={(text) => setMessage(text)}
            value={message}
            placeholder="Type here..."
            multiline
            numberOfLines={3}
          />
          <TouchableOpacity
            style={styles.imagePickerButton}
            onPress={pickImage}
          >
            <Ionicons
              style={styles.imageIcon}
              name="image-outline"
              color="white"
            />
            <CustomizeText style={styles.imagePickerButtonText}>
              Attach
            </CustomizeText>
          </TouchableOpacity>
          {image && (
            <Image
              source={{ uri: image }}
              style={{ width: 200, height: 200 }}
            />
          )}
          <TouchableOpacity style={styles.submitButton} onPress={handleSubmit}>
            <CustomizeText style={styles.submitButtonText}>
              Submit
            </CustomizeText>
          </TouchableOpacity>
        </ScrollView>
      </SafeAreaView>
    </View>
  );
};

export default withUserContext(CheckIn);
